import {
  IconBrazil, IconBulgaria, IconChina, IconCzechia, IconDenmark,
  IconEstonia, IconFinland, IconFrance, IconGermany, IconGreece,
  IconHungary, IconIndonesia, IconItaly, IconJapan, IconLatvia,
  IconLithuania, IconNetherlands, IconNorway, IconPoland, IconPortugal,
  IconRomania, IconRussia, IconSaudiArabia, IconSlovakia, IconSlovenia,
  IconSouthKorea, IconSpain, IconSweden, IconTaiwan, IconTurkey,
  IconUkraine, IconUnitedKingdom, IconUnitedStates,
} from "nucleo-flags";
import type { Language } from "./types.ts";

export const languages: Language[] = [
  { code: "AR", name: "Arabic", Flag: IconSaudiArabia },
  { code: "BG", name: "Bulgarian", Flag: IconBulgaria },
  { code: "CS", name: "Czech", Flag: IconCzechia },
  { code: "DA", name: "Danish", Flag: IconDenmark },
  { code: "DE", name: "German", Flag: IconGermany },
  { code: "EL", name: "Greek", Flag: IconGreece },
  { code: "EN-GB", name: "English (UK)", Flag: IconUnitedKingdom },
  { code: "EN-US", name: "English (US)", Flag: IconUnitedStates },
  { code: "ES", name: "Spanish", Flag: IconSpain },
  { code: "ES-419", name: "Spanish (LatAm)", Flag: IconSpain },
  { code: "ET", name: "Estonian", Flag: IconEstonia },
  { code: "FI", name: "Finnish", Flag: IconFinland },
  { code: "FR", name: "French", Flag: IconFrance },
  { code: "HU", name: "Hungarian", Flag: IconHungary },
  { code: "ID", name: "Indonesian", Flag: IconIndonesia },
  { code: "IT", name: "Italian", Flag: IconItaly },
  { code: "JA", name: "Japanese", Flag: IconJapan },
  { code: "KO", name: "Korean", Flag: IconSouthKorea },
  { code: "LT", name: "Lithuanian", Flag: IconLithuania },
  { code: "LV", name: "Latvian", Flag: IconLatvia },
  { code: "NB", name: "Norwegian", Flag: IconNorway },
  { code: "NL", name: "Dutch", Flag: IconNetherlands },
  { code: "PL", name: "Polish", Flag: IconPoland },
  { code: "PT-BR", name: "Portuguese (Brazil)", Flag: IconBrazil },
  { code: "PT-PT", name: "Portuguese (Portugal)", Flag: IconPortugal },
  { code: "RO", name: "Romanian", Flag: IconRomania },
  { code: "RU", name: "Russian", Flag: IconRussia },
  { code: "SK", name: "Slovak", Flag: IconSlovakia },
  { code: "SL", name: "Slovenian", Flag: IconSlovenia },
  { code: "SV", name: "Swedish", Flag: IconSweden },
  { code: "TR", name: "Turkish", Flag: IconTurkey },
  { code: "UK", name: "Ukrainian", Flag: IconUkraine },
  { code: "ZH-HANS", name: "Chinese (Simplified)", Flag: IconChina },
  { code: "ZH-HANT", name: "Chinese (Traditional)", Flag: IconTaiwan },
];

export const sourceLangs: Language[] = [
  { code: "AR", name: "Arabic", Flag: IconSaudiArabia },
  { code: "BG", name: "Bulgarian", Flag: IconBulgaria },
  { code: "CS", name: "Czech", Flag: IconCzechia },
  { code: "DA", name: "Danish", Flag: IconDenmark },
  { code: "DE", name: "German", Flag: IconGermany },
  { code: "EL", name: "Greek", Flag: IconGreece },
  { code: "EN", name: "English", Flag: IconUnitedKingdom },
  { code: "ES", name: "Spanish", Flag: IconSpain },
  { code: "ET", name: "Estonian", Flag: IconEstonia },
  { code: "FI", name: "Finnish", Flag: IconFinland },
  { code: "FR", name: "French", Flag: IconFrance },
  { code: "HU", name: "Hungarian", Flag: IconHungary },
  { code: "ID", name: "Indonesian", Flag: IconIndonesia },
  { code: "IT", name: "Italian", Flag: IconItaly },
  { code: "JA", name: "Japanese", Flag: IconJapan },
  { code: "KO", name: "Korean", Flag: IconSouthKorea },
  { code: "LT", name: "Lithuanian", Flag: IconLithuania },
  { code: "LV", name: "Latvian", Flag: IconLatvia },
  { code: "NB", name: "Norwegian", Flag: IconNorway },
  { code: "NL", name: "Dutch", Flag: IconNetherlands },
  { code: "PL", name: "Polish", Flag: IconPoland },
  { code: "PT", name: "Portuguese", Flag: IconPortugal },
  { code: "RO", name: "Romanian", Flag: IconRomania },
  { code: "RU", name: "Russian", Flag: IconRussia },
  { code: "SK", name: "Slovak", Flag: IconSlovakia },
  { code: "SL", name: "Slovenian", Flag: IconSlovenia },
  { code: "SV", name: "Swedish", Flag: IconSweden },
  { code: "TR", name: "Turkish", Flag: IconTurkey },
  { code: "UK", name: "Ukrainian", Flag: IconUkraine },
  { code: "ZH", name: "Chinese", Flag: IconChina },
];
